/**
 * --- Inline ADR ---
 * Какие варианты реализации были рассмотрены:
 * - 1. можно заранее собирать структуру классов, которая повторяет структуру узлов, а потом "рендерить ее"
 *   лишний код, лишняя сложность, засорение проекта еще одной структурой классов;
 * - 2. [ВЫБРАННОЕ РЕШЕНИЕ] реализовать getter'ы для компонент, рассчитывать все данные в изолированном хуке,
 *   давая интерфейс на получение конкретного объекта
 *   как в этом случае будет реализованы скоупы данных? - Можно рассчитывать их в том же изолированном хуке,
 *   в этом случае можно будет получать конкретный узел уже с имеющимися скоупами.
 * - 3. Оборачивать компоненты React-контекстом, в котором будут данные узла и данные скоупов
 *   вносим ограничение к тому, как должны строиться компоненты. - По факту любой connect тоже вносит это ограничение
 *   а как тогда делать получение данных контекста в изолированных редакторах по одному узлу? Вероятно костылями)
 * + из плюшек, получаем простой расчет локального контекста данных
 * + Какие преимущества есть, от оборачивания? - в случае изменений, возможно каких-то переменных,
 *   мы получаем контекст-зависимые изменения;
 */

import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { Outer } from "../components/Outer";
// FIXME: Very hacky solution for now, should be fixed and cleaned up during library preparation, not execution
export var extendNode = function extendNode(WrappedComponent) {
  var ModifiedComponent = function ModifiedComponent(props) {
    return /*#__PURE__*/React.createElement(Outer, props.extra, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
  hoistNonReactStatics(ModifiedComponent, WrappedComponent);
  return ModifiedComponent;
};